/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { IconCaretDownFilled, IconCaretUpFilled } from '@tabler/icons-react';
import NSIcon from 'bricks/NSIcon/NSIcon';
import React from 'react';
import './SortingIcon.scss';

export type SortingIconProps = {
    isSorted: boolean;
    sortedDirection: 'asc' | 'desc' | null;
    columnId: string;
    onAscendingSort: () => void;
    onDescendingSort: () => void;
    onClearSort?: () => void;
};

export const SortingIcon: React.FC<SortingIconProps> = ({
    isSorted, sortedDirection, columnId, onAscendingSort, onDescendingSort, onClearSort,
}) => {
    const handleSort = () => {
        if (!isSorted) {
            onAscendingSort();
            return;
        }
        if (sortedDirection === 'asc') {
            onDescendingSort();
        } else if (onClearSort) {
            onClearSort();
        } else {
            onAscendingSort();
        }
    };

    return (
        <div className="d-flex flex-column align-items-center SortingIcon cursor--pointer " onClick={handleSort}>
            <NSIcon
                data-testid={`sort-${columnId}-up`}
                id={`sort-${columnId}-up`}
                icon={IconCaretUpFilled}
                className={`SortingIcon__icon ${isSorted && sortedDirection === 'asc' ? 'active' : 'text-muted'}`}
            />
            <NSIcon
                data-testid={`sort-${columnId}-down`}
                id={`sort-${columnId}-down`}
                icon={IconCaretDownFilled}
                className={`SortingIcon__icon ${isSorted && sortedDirection === 'desc' ? 'active' : 'text-muted'}`}
            />
        </div>
    );
};

export default SortingIcon;
